/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PersonalizationRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#search
 */
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_search',
  args: ['queryType', 'search', 'productTypes', 'language', 'collectionId', 'filter', 'sorts', 'offset', 'length'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSearchFilterDefinitions
 */
export const GET_SEARCH_FILTER_DEFINITIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSearchFilterDefinitions',
  args: ['language'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getSearchFilterDefinitionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSections
 */
export const GET_SUGGESTION_SECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSections',
  args: ['maximumSections', 'language', 'minimumSectionCardCount', 'maximumSectionCardCount', 'productTypes'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getSuggestionSectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});